const data_it = ``;

const data_en = ``;

export {data_it, data_en};
